import React, {useEffect, useState} from 'react';
import {useList} from "react-use";
import lodash from 'lodash';
import {useSelector} from "react-redux";
import Checkbox from "../../../../../components/checkbox";

import {Collapse} from 'react-collapse';

function LeftRightBat(props) {
    const [isOpened, setIsOpened] = useState(false);
    const {selected} = props;
    const typeSearch = useSelector(state => state.detailSearch.type);
    const [title, setTitle] = useState('対左右');
    const [leftRightBat, leftRightBatHelper] = useList([
        {
            value: 1,
            name: '左',
            checked: false,
        },
        {
            value: 2,
            name: '右',
            checked: false,
        }
    ]);
    useEffect(() => {
        if(typeSearch === 'pitchers') {
            leftRightBat.map(item => {
                item.name = item.name.slice(0, 1) + '打席';
            });
            setTitle(title.slice(0, 3) + '打席')
            return;
        }
        leftRightBat.map(item => {
            item.name = item.name.slice(0, 1) + '投手';
        })
        setTitle(title.slice(0, 3) + '投手')
    },[typeSearch])
    useEffect(() => {
        if(selected.length === 0) return;
        selected.map(item => {
            const index = leftRightBat.findIndex(i => i.value === item);
            leftRightBat[index].checked = true;
        })
    },[selected])
    useEffect(() => {
        props.onChange(lodash.map(lodash.filter(leftRightBat,['checked', true]), 'value'));
    },[leftRightBat]);

    const onChange = (item, index) => {
        leftRightBatHelper.updateAt(index,{...item,checked: !item.checked});
    };
    // const isOpenCollapse = () => {
    //     setIsOpened()
    // }

    return (
            <div className="group-filter-item">
               <div className={'open-collapse'}>
                   <div className='toggle-collapse' onClick={()=> setIsOpened(!isOpened)}>
                       <h4>{title}</h4>
                       <img src="/img/chevron_down_24px.svg" alt="arrow-down" style={{transform:isOpened === true && 'rotate(180deg)'}}/>
                   </div>

                   <Collapse isOpened={isOpened} isResting={true}>
                       <div style={{ display: "flex"}}>
                           {leftRightBat.map((item, index) => {
                               return <div key={item.value} className={'search-main-advanced-checkbox'}>
                                   <label>
                                       <Checkbox onChange={() => onChange(item, index)} value={item.value} checked={item.checked}/>
                                       {item.name}
                                   </label>
                               </div>
                           })}
                       </div>
                   </Collapse>
               </div>
                <div className={'close-collapse'}>
                    <div>
                        <h4>{title}</h4>
                    </div>

                        <div style={{ display: "flex"}}>
                            {leftRightBat.map((item, index) => {
                                return <div key={item.value} className={'search-main-advanced-checkbox'}>
                                    <label>
                                        <Checkbox onChange={() => onChange(item, index)} value={item.value} checked={item.checked}/>
                                        {item.name}
                                    </label>
                                </div>
                            })}
                        </div>
                </div>
            </div>

    )
}

export default LeftRightBat;
